/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : appTheme.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Tahir Shaik
 * @description App Theme  Should Be declared Here and will use in entire app
 * @date 11-06-2024
 * @version 0.0.1 - Initial Release
 */

import { customAppColors } from "../app-theme/appColors";

const appTheme = {
  primaryColor: "primary",
  secondaryColor: "secondary",
  buttonTextSize: ".8rem",
  textSize: "18px",
  textHeadingSize: "20px",
  fontSizeSmall: ".8rem",
  fontSizeMedium: ".9rem",
  fontSizeLarge: "1rem",
  fontSizexl: "1.2rem",
  fontSizexs: ".7rem",
  commonBtnStyle1: {
    color: "white",
    // color: "black",
    // backgroundImage: "linear-gradient( to bottom, rgb(7, 5, 69), rgb(103, 86, 133))",
    backgroundColor: "#26890D",
    maxHeight: "30px",
    width: "fit-content",
    // borderRadius: "20px",
    "&:hover": {
      // backgroundImage: "linear-gradient(#6b8df2,#021636)",
      backgroundColor: "#26890D",
    },
    "&.Mui-disabled": {
      color: "#26890D",
      // color: "#666666",
      backgroundImage:
        "linear-gradient(to bottom, rgb(169, 169, 169), rgb(211, 211, 211))", // Light grey gradient
      // backgroundColor: "#0F3705",
      cursor: "not-allowed",
    },
  },
  commonBtnStyle: {
    color: "white",
    // color: "black",
    // backgroundImage: "linear-gradient( to bottom, rgb(7, 5, 69), rgb(103, 86, 133))",
    backgroundColor: customAppColors?.green,
    maxHeight: "30px",
    width: "fit-content",
    borderRadius: "20px",
    "&:hover": {
      // backgroundImage: "linear-gradient(#6b8df2,#021636)",
      backgroundColor: customAppColors?.lightGreen,
    },
    "&.Mui-disabled": {
      color: "rgba(255, 255, 255, 0.7)",
      // color: "#666666",
      backgroundImage:
        "linear-gradient(to bottom, rgb(169, 169, 169), rgb(211, 211, 211))", // Light grey gradient
      // backgroundColor: "#0F3705",
      cursor: "not-allowed",
    },
  },
};

export default appTheme;
